import React from 'react';
import PropTypes from 'prop-types';

import StudyListTableRow from './StudyListTableRow';

const StudyListTable = ({ tableDataSource, querying }) => {
  return (
    <div className="w-full bg-gray-50 px-6 py-6">
      <div className="mx-auto w-full max-w-7xl overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        {/* Table Header */}
        <div className="border-b border-gray-200 bg-gray-50 px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-base font-semibold text-gray-900">Studies</h2>

              <p className="mt-0.5 text-xs text-gray-500">Available studies</p>
            </div>

            {querying && (
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <span className="h-2 w-2 animate-pulse rounded-full bg-red-500" />
                Loading...
              </div>
            )}
          </div>
        </div>

        {/* Table */}
        <div className="w-full overflow-x-auto">
          <table className="w-full min-w-[700px] border-collapse text-left text-sm text-gray-900">
            <tbody
              data-cy="study-list-results"
              data-querying={querying}
              className="divide-y divide-gray-100"
            >
              {tableDataSource.map((tableData, i) => (
                <StudyListTableRow
                  tableData={tableData}
                  key={i}
                />
              ))}
            </tbody>
          </table>
        </div>

        {/* Empty State */}
        {!querying && tableDataSource.length === 0 && (
          <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
            <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
              <span className="text-lg text-gray-400">—</span>
            </div>

            <p className="text-sm font-medium text-gray-700">No studies found</p>

            <p className="mt-1 text-xs text-gray-500">
              There are no studies available for the selected criteria.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

StudyListTable.propTypes = {
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      expandedContent: PropTypes.node.isRequired,
      querying: PropTypes.bool,
      onClickRow: PropTypes.func.isRequired,
      isExpanded: PropTypes.bool.isRequired,
    })
  ),
};

export default StudyListTable;
